import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FilterWidget } from '@sorare/core/src/lib/filters';

import { FILTER, Title } from 'searchCards/CustomDecksFilter';
import { SportCustomDecksFilter } from 'searchCards/CustomDecksFilter/SportCustomDecksFilter';

export const widget: FilterWidget = {
  key: FILTER.name,
  type: 'virtualToggle',
  filter: FILTER,
  Component: ({ visible }) => (
    <SportCustomDecksFilter sport={Sport.NBA} visible={visible} />
  ),
  title: <Title />,
  accordionOptions: { startsOpen: true },
};
